import { DependencyList, useEffect, useState } from "react";

export function useRunEffectOnceIf(
  shouldRunFn: () => boolean,
  deps: DependencyList,
): void {
  const [hasRun, setHasRun] = useState(false);

  useEffect(() => {
    if (!hasRun && shouldRunFn()) {
      setHasRun(true);
    }
  }, [shouldRunFn, hasRun, ...deps]);
}
